import { Role } from './roles';

enum Page {
  ROOT = 'ROOT',
  PMO = 'PMO',
  TEACHERPAYMENT = 'TEACHERPAYMENT',
  EVENTS = 'EVENTS',
  SHARING = 'SHARING',
  DEBITNOTES = 'DEBITNOTES',
  ACCOUNTINGACCOUNT = 'ACCOUNTINGACCOUNT',
  PERCENTAGECHARGE = 'PERCENTAGECHARGE',
  BRANCHRESULTCENTER = 'BRANCHRESULTCENTER',
  PERMISSIONSBYPRODUCTS = 'PERMISSIONSBYPRODUCTS',
  NOSHARING = 'NOSHARING',
  CLASSIFYINCENTIVIZED = 'CLASSIFYINCENTIVIZED',
}

/**
 * Since every page is accessed only if the user owns certain roles,
 * we must define a set of Pages and the roles of every page
 */

export const PAGE_ROLES: Record<Page, Array<string>> = {
  ROOT: [Role.ADMIN, Role.CONTROLLERSHIP],
  PMO: [Role.ADMIN, Role.CONTROLLERSHIP],
  TEACHERPAYMENT: [Role.CONTROLLERSHIP],
  EVENTS: [Role.CONTROLLERSHIP],
  SHARING: [Role.CONTROLLERSHIP],
  DEBITNOTES: [Role.CONTROLLERSHIP],
  ACCOUNTINGACCOUNT: [Role.CONTROLLERSHIP],
  PERCENTAGECHARGE: [Role.CONTROLLERSHIP],
  BRANCHRESULTCENTER: [Role.CONTROLLERSHIP],
  PERMISSIONSBYPRODUCTS: [Role.CONTROLLERSHIP],
  NOSHARING: [Role.CONTROLLERSHIP],
  CLASSIFYINCENTIVIZED: [Role.CONTROLLERSHIP],
};

export const PAGE_PATHS: Record<Page, string> = {
  ROOT: '/',
  PMO: '/pmosharing',
  TEACHERPAYMENT: '/teacherpayment',
  EVENTS: '/events',
  SHARING: '/sharing',
  DEBITNOTES: '/debitnote',
  ACCOUNTINGACCOUNT: '/accountingaccount',
  PERCENTAGECHARGE: '/percentagecharge',
  BRANCHRESULTCENTER: '/branchresultcenter',
  PERMISSIONSBYPRODUCTS: '/permissionByProduct',
  NOSHARING: '/nosharing',
  CLASSIFYINCENTIVIZED: '/classifyincentivized',
};

export default Page;
